var _circle, _g, _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotificationsFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 80,
    viewBox: "0 0 89 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_1219_55004)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7704 23.2295L38.2646 26.6778L36.1956 61.8502L21.7129 58.4019L26.7704 23.2295Z",
    fill: "#1E2C3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5979 23.9191L63.0922 26.9077L67.0002 61.8502L51.5979 58.4019V23.9191Z",
    fill: "#1E2C3F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.3887,
    y: 26.5947,
    width: 27.4001,
    height: 38.4979,
    rx: 0.581999,
    transform: "rotate(-9.28297 14.3887 26.5947)",
    fill: "#BDC3C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.039 62.518C23.0639 62.6297 23.172 62.7023 23.2849 62.6831L45.0941 58.9742C45.2059 58.9552 45.2836 58.8527 45.2719 58.74L44.8443 54.6384C44.8419 54.6159 44.836 54.5938 44.8268 54.5731L43.8134 52.3026C43.7684 52.2019 43.6546 52.1516 43.5498 52.186L22.4805 59.1215C22.3755 59.156 22.3138 59.2646 22.3379 59.3724L23.039 62.518Z",
    fill: "#ADB9BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3779 23.9106L16.7012 27.6409C16.3841 27.6931 16.1692 27.9925 16.2214 28.3096L21.6802 61.4936C21.7323 61.8108 22.0318 62.0256 22.3489 61.9734L45.0256 58.2431C45.3428 58.191 45.5576 57.8916 45.5054 57.5744L40.0467 24.3904C39.9945 24.0732 39.6951 23.8584 39.3779 23.9106Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6538 24.1396L33.5281 22.3507C33.8982 22.2899 34.2488 22.5405 34.3099 22.9117L34.6879 25.2095C34.74 25.5266 34.5252 25.8261 34.208 25.8782L23.1396 27.699C22.8224 27.7512 22.523 27.5363 22.4708 27.2192L22.0929 24.9214C22.032 24.5512 22.2826 24.2006 22.6538 24.1396Z",
    fill: "#8E9EAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5425 22.8616C29.538 22.5054 29.2175 22.2368 28.866 22.2946L27.0828 22.588C26.7348 22.6452 26.5173 22.9963 26.621 23.3334L27.077 24.8155C27.1625 25.0937 27.4405 25.2659 27.7277 25.2187L29.0746 24.9972C29.3585 24.9505 29.5657 24.7033 29.5621 24.4156L29.5425 22.8616Z",
    fill: "#8E9EAE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2578,
    y: 16.043,
    width: 34.8736,
    height: 48.9984,
    rx: 0.740741,
    transform: "rotate(-0.801501 29.2578 16.043)",
    fill: "#ADB9BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4016 62.8872C33.412 63.0325 33.5344 63.1442 33.6801 63.1413L61.8305 62.5663C61.9748 62.5634 62.0919 62.4489 62.0983 62.3048L62.3299 57.0614C62.3312 57.0325 62.3279 57.0037 62.3201 56.9759L61.4707 53.9275C61.433 53.7923 61.2991 53.7075 61.1608 53.7312L33.3361 58.5067C33.1974 58.5305 33.0994 58.6556 33.1095 58.7959L33.4016 62.8872Z",
    fill: "#8E9EAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2175 17.3526L31.9711 17.7916C31.5621 17.7978 31.2354 18.1343 31.2416 18.5434L31.884 61.3413C31.8902 61.7503 32.2267 62.0769 32.6358 62.0708L61.8822 61.6318C62.2913 61.6256 62.6179 61.2891 62.6118 60.88L61.9693 18.0821C61.9632 17.6731 61.6266 17.3465 61.2175 17.3526Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1217 14.5036L54.1464 14.2931C54.6238 14.2859 55.0181 14.6672 55.0253 15.1459L55.0698 18.1095C55.0759 18.5185 54.7493 18.8551 54.3402 18.8612L40.0651 19.0755C39.6561 19.0817 39.3195 18.755 39.3133 18.346L39.2689 15.3825C39.2617 14.9051 39.643 14.5108 40.1217 14.5036Z",
    fill: "#5E6974"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0321 14.1876C49.0933 13.7384 48.7402 13.3401 48.287 13.3469L45.9871 13.3814C45.5383 13.3882 45.1986 13.7893 45.2658 14.2331L45.5616 16.1845C45.6171 16.5507 45.9347 16.8197 46.3051 16.8141L48.0422 16.7882C48.4084 16.7827 48.7156 16.5104 48.7651 16.1475L49.0321 14.1876Z",
    fill: "#5E6974"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8174 19.5146L81.1108 18.2401L77.8932 16.9948L76.5833 13.334L75.3063 16.9032L71.8516 18.2401L75.3821 19.6063L76.5833 22.9636L77.8174 19.5146Z",
    fill: "#BDC3C8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1219_55004",
    x1: 35.2644,
    y1: -136.092,
    x2: 44,
    y2: 111.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4F6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotificationsFound);
export default __webpack_public_path__ + "static/media/no-notifications-found.c7e562877e5727841a40b309d6d0301b.svg";
export { ForwardRef as ReactComponent };